export const TYPE_NUMBER = {
    STATIC: 1,
    DYNAMIC: 2,
}
